import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import FaIcon from './FaIcon';
import { GettonciniIcon } from '../icons';
import modalStyles from '../styles/modal.module.css';
import buttonStyles from '../styles/Button.module.css';
import styles from '../styles/AccountChangeNoticeModal.module.css';
import { GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES } from '../ads/googleInterstitialAttributes';

const AccountChangeNoticeModal = ({ onDismiss, onAccountClick }) => {
  return (
    <div className={modalStyles.modalContent}>
      <div className={styles.content}>
        <div className={styles.hero}>
          <span className={styles.stellineIcon} aria-hidden="true">
            <FaIcon className={`fa-solid fa-star ${styles.stellineIconGlyph}`} />
          </span>
        </div>

        <p className={styles.description}>
          Le <strong>stelline</strong> premiano la tua abilità nei giochi e mostrano i tuoi progressi settimana dopo settimana. Le ottieni giocando, completando sfide e essendo costante.
        </p>

        <div className={styles.gettonciniIconWrap} aria-hidden="true">
          <GettonciniIcon size={56} />
        </div>

        <p className={styles.description}>
          I <strong>gettoncini</strong> restano attivi per sbloccare aiutini e imparare con Lella;
          li trovi ora nella pagina <Link to="/account" className={styles.accountLink} onClick={onAccountClick} {...GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES}>account</Link>.
        </p>

        <div className={styles.actions}>
          <Button
            primary
            className={`${buttonStyles.primaryBlue} ${buttonStyles.inline}`}
            onClick={onDismiss}
          >
            Ho capito
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccountChangeNoticeModal;
